import { useFormikContext } from 'formik';
import { FC } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { QcsTextField } from '../basic/QcsTextField';
import _ from 'lodash';
import { PASSWORD_MANAGER_IGNORE_PROPS } from '../../../utils/constants';

interface Props {
  className?: string;
  fullWidth?: boolean;
  required?: boolean;
  type?: React.InputHTMLAttributes<unknown>['type'];
  name: string;
  label?: React.ReactNode;
  shrinkLabel?: boolean;
  maxLength?: number;
  multiline?: boolean;
  rows?: number;
  disabled?: boolean;
  min?: number;
  max?: number;
  inputRef?: React.Ref<HTMLInputElement>;
  autoFocus?: boolean;
  autoComplete?: string;
  onBlur?: (e: any) => void;
  removeSpaces?: boolean;
  disablePasswordManager?: boolean;
  clearable?: boolean;
}

export const Input: FC<Props> = ({
  className,
  fullWidth,
  required,
  type,
  name,
  label,
  shrinkLabel,
  maxLength,
  multiline,
  rows,
  disabled,
  min,
  max,
  inputRef,
  autoFocus,
  autoComplete,
  onBlur,
  removeSpaces,
  disablePasswordManager,
  clearable,
}) => {
  const { values, errors, touched, submitCount, handleChange, handleBlur, setFieldValue } = useFormikContext<any>();

  const value = _.get(values, name);
  const showClear = clearable && !disabled && value !== null && value !== undefined && value !== '';
  const wasTouched = !!submitCount || !!_.get(touched, name);
  const errorText = _.get(errors, name) as string;
  const hasError = !!errorText;

  const handleRemoveSpaces = (value: string) => setFieldValue(name, value.replace(/\s/g, ''));

  //Disable change value by wheel on number inputs.
  const handleWheel = (e: React.WheelEvent<HTMLDivElement>) => {
    if (type !== 'number') {
      return;
    }

    e.stopPropagation();
    e.preventDefault();
    (e.target as any).blur();
  };

  return (
    <QcsTextField
      className={className}
      required={required}
      fullWidth={fullWidth}
      id={name}
      type={type}
      name={name}
      label={label}
      shrinkLabel={shrinkLabel}
      value={value === null || value === undefined ? '' : value}
      onChange={handleChange}
      onBlur={(e) => {
        handleBlur(e);
        if (removeSpaces) handleRemoveSpaces(e.target.value)
        if (onBlur) onBlur(e);
      }}
      onWheel={handleWheel}
      error={wasTouched && hasError}
      helperText={wasTouched && errorText}
      htmlInputProps={{ maxLength, min, max, autoComplete, ...(disablePasswordManager && PASSWORD_MANAGER_IGNORE_PROPS) }}
      endAdornment={
        showClear ? (
          <InputAdornment position="end">
            <IconButton edge="end" size="small" onClick={() => setFieldValue(name, '')}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : undefined
      }
      multiline={multiline}
      rows={rows}
      disabled={disabled}
      inputRef={inputRef}
      autoFocus={autoFocus}
    />
  );
};
